var _style, _path, _rect, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReminderBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 357 451",
    style: {
      enableBackground: "new 0 0 357 451"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FCA66C;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#324561;}\r\n\t.st3{fill:none;stroke:#324561;stroke-width:21;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.5,435.4h-273C23.3,435.4,6,418.1,6,396.9v-338C6,28.8,30.6,4.2,60.7,4.2h236.7c30.1,0,54.7,24.6,54.7,54.7 v342C352,419.9,336.5,435.4,317.5,435.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 364.4,
    className: "st1",
    width: 328.5,
    height: 70.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.8,112.4H103.2c-5.9,0-10.7-4.8-10.7-10.7v0c0-5.9,4.8-10.7,10.7-10.7h163.5c5.9,0,10.8,4.8,10.8,10.7v0 C277.5,107.6,272.7,112.4,266.8,112.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.8,166.9h-95.5c-5.9,0-10.7-4.8-10.7-10.7v0c0-5.9,4.8-10.7,10.7-10.7h95.5c5.9,0,10.7,4.8,10.7,10.7v0 C209.5,162.1,204.7,166.9,198.8,166.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.8,362.9H50.5c-19,0-34.5,15.5-34.5,34.5v5c0,19,15.5,34.5,34.5,34.5h291.3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderBook);
export default __webpack_public_path__ + "static/media/reminder_book.302f561b223dbc388b4373356b888160.svg";
export { ForwardRef as ReactComponent };